import Usuarios   from "@/components/Pages/Cadastro/Usuarios.vue"
import Unidades   from "@/components/Pages/Cadastro/Unidades.vue"
import Setores    from "@/components/Pages/Cadastro/Setores.vue"
import Ramais     from "@/components/Pages/Cadastro/Ramais.vue"

export default [
	{
		name: "Usuarios",
		path: ":get",
		component: Usuarios,
		props: true
	},

	{
		name: "Unidades",
		path: ":get",
		component: Unidades,
		props: true
	},

	{
		name: "Setores",
		path: ":get",
		component: Setores,
		props: true
	},

	{
		name: "Ramais",
		path: ":get",
		component: Ramais,
		props: true
	}
]